import { IdentityAuthProviderService } from '../common/auth/identity-auth-provider.service';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import * as moment from 'moment';
import {CaseQuote} from '@app/shared/models/case-quote';
import {AssociatedQuote} from '@app/shared/models/associated-quote';

@Injectable()
export class QuoteStatusService {

    constructor(
        private _authService: IdentityAuthProviderService
    ) {}

    updateQuoteStatus(
        quoteGuids: Array<string>,
        brokerGuid: string,
        status: number,
        isApproved: boolean = false,
        coverReason: string | null = null,
        businessAssuranceType: string | null = null,
        policyHolderIsInsuredLife: string | null = null,
        primaryQuoteGuid: string | null = null,
        lifeInsuredId: string | null = null,
        initialQuircStatus: string | null = null,
        wasInitiallyReferred: boolean | null = null,

    ) {
        let customHeaders = {
            [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
            'Authorization': 'Bearer ' + abp.auth.getToken()
        };

        let data = {
            'quoteGuids' : quoteGuids,
            'status' : status,
            'timeStamp' : moment(),
            'isApproved' : isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
            'currentUserGuid': this._authService.user.profile.sub,
            'primaryQuoteGuid': primaryQuoteGuid,
            'lifeInsuredid': lifeInsuredId,
            'initialQuircStatus': initialQuircStatus,
            'wasInitiallyReferred': wasInitiallyReferred,
        };

        XmlHttpRequestHelper.ajax(
            'PUT',
            AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/UpdateQuoteStatus',
            customHeaders,
            JSON.stringify(data),
            result => {
                // console.log('updateQuoteStatus', result);
            }
        );
    }

    pushMessages(quoteGuids: Array<string>, brokerGuid: string, status: number, isApproved: boolean = false,
        coverReason: string | null = null, businessAssuranceType: string | null = null, policyHolderIsInsuredLife: string | null = null, primaryQuoteGuid: string | null = null): void {
        let customHeaders = {
            [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
            'Authorization': 'Bearer ' + abp.auth.getToken()
        };

        let data = {
            'quoteGuids' : quoteGuids,
            'status' : status,
            'timeStamp' : moment(),
            'isApproved' : isApproved,
            'accessToken': this._authService.user.access_token,
            'brokerGuid': brokerGuid,
            'coverReason': coverReason,
            'businessAssuranceType': businessAssuranceType,
            'policyHolderIsInsuredLife': policyHolderIsInsuredLife,
            'currentUserGuid': this._authService.user.profile.sub,
            'primaryQuoteGuid': primaryQuoteGuid
            };

        XmlHttpRequestHelper.ajax(
            'POST',
            AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/PushMessages',
            customHeaders,
            JSON.stringify(data),
            result => {}
        );
    }

    getPrimaryQuote(quoteGuid: string): Promise<CaseQuote> {
        return new Promise<CaseQuote>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            XmlHttpRequestHelper.ajax(
                'GET',
                AppConsts.remoteServiceBaseUrl + `/api/services/app/QuoteStatus/GetPrimaryQuote?quoteGuid=${quoteGuid}`,
                customHeaders,
                null,
                result => { resolve(result.result); }
            );
        });
    }

    logDeclarationOfHealth(quoteGuids: Array<string>): Promise<void> {
        return new Promise<void>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            let data = {
                'quoteGuids' : quoteGuids,
                'currentUserGuid': this._authService.user.profile.sub,
                'accessToken': abp.auth.getToken()
            };

            XmlHttpRequestHelper.ajax(
                'POST',
                AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/LogDeclarationOfHealth',
                customHeaders,
                JSON.stringify(data),
                result => { resolve(); }
            );
        });
    }

    expireQuoteStatus(quoteGuid: string): Promise<void> {
        return new Promise<void>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            let data = {
                'quoteGuid' : quoteGuid,
                'currentUserGuid': this._authService.user.profile.sub,
                'accessToken': this._authService.user.access_token
            };

            XmlHttpRequestHelper.ajax(
                'POST',
                AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/ExpireQuote',
                customHeaders,
                JSON.stringify(data),
                result => { resolve(); }
            );
        });
    }

    listActiveCases(): Promise<CaseQuote[]> {
        return new Promise<CaseQuote[]>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            // AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/GetActiveCases',
            XmlHttpRequestHelper.ajax(
                'GET',
                `${AppConsts.remoteServiceBaseUrl}/api/services/app/QuoteStatus/GetActiveCases?brokerId=${this._authService.user.profile.sub}&accessToken=${this._authService.user.access_token}`,
                customHeaders,
                null,
                resp => { resolve(resp.result); }
            );
        });
    }

    listAssociatedQuotes(primaryQuoteGuid: string): Promise<AssociatedQuote[]> {
        return new Promise<AssociatedQuote[]>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            // AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/GetActiveCases',
            XmlHttpRequestHelper.ajax(
                'GET',
                `${AppConsts.remoteServiceBaseUrl}/api/services/app/QuoteStatus/GetAssociatedQuotes?quoteGuid=${primaryQuoteGuid}`,
                customHeaders,
                null,
                resp => { resolve(resp.result); }
            );
        });
    }

    searchCases(searchTerm: string): Promise<CaseQuote[]> {
        return new Promise<CaseQuote[]>(resolve => {
            let customHeaders = {
                [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
                'Authorization': 'Bearer ' + abp.auth.getToken()
            };

            const data = {
                'brokerId': this._authService.user.profile.sub,
                'searchTerm': searchTerm,
                'accessToken': this._authService.user.access_token
            };

            // AppConsts.remoteServiceBaseUrl + '/api/services/app/QuoteStatus/GetActiveCases',
            XmlHttpRequestHelper.ajax(
                'POST',
                `${AppConsts.remoteServiceBaseUrl}/api/services/app/QuoteStatus/SearchCases`,
                customHeaders,
                JSON.stringify(data),
                resp => { resolve(resp.result); }
            );
        });
    }
}
